export const DPS_START = 'DPS_START';
export const DPS_SUCCESS = 'DPS_SUCCESS';
export const DPS_FAIL = 'DPS_FAIL';
export const DPS_FINISH = 'DPS_FINISH';
export const CLEAN_DPS = 'CLEAN_DPS';
